// The forecast column's place in the report table, shared by the controller that
// builds it and the inline column editor, which has to leave it alone and keep it
// last.
//
// It used to be found by `:last-child`, which was the same thing as long as the
// forecast column was the only thing appended to the report's rows. The column
// editor appends preview cells of its own, so the column is marked instead of
// positioned.

export const FORECAST_CELL_ATTRIBUTE = 'data-forecast-cell'
export const FORECAST_CELL_SELECTOR = `[${FORECAST_CELL_ATTRIBUTE}]`

// The forecast column's cell in one row, if it has one. What the column editor
// puts its own cells in front of, so the forecast column stays at the end.
export const forecastCellIn = (
  row: HTMLTableRowElement
): HTMLTableCellElement | null =>
  row.querySelector<HTMLTableCellElement>(FORECAST_CELL_SELECTOR)

// The rows a forecast column was built against, in order.
//
// A forecast cell holds the value of the row it sits in, and the two are paired
// by position (see updateForecastColumn) — so a column can only be put back on a
// table whose rows are the same ones, in the same order. What the report renders
// as rows follows from its elements rather than from its columns, so applying
// columns does not change them; this is what says so at the moment it matters,
// because the alternative is forecast values landing silently against the wrong
// accounts.
//
// Only identified rows are named; for the rest this is a count and an ordering.
export const reportRowFingerprint = (table: ParentNode): string =>
  Array.from(table.querySelectorAll<HTMLTableRowElement>('tbody tr'))
    .map(
      (row) => row.id || row.dataset.accountId || row.dataset.identifier || ''
    )
    .join('|')
